import { wxApi } from '@/api/basic/wx/index';
import wx from 'weixin-js-sdk';
let brower = {
  version: (function() {
    var u = navigator.userAgent;
    var userId = getUserAgentKey(u, 'userId/');
    var appId = getUserAgentKey(u, 'appId/');
    var currentSiteId = getUserAgentKey(u, 'currentSiteId/');

    return {
      //移动终端浏览器版本信息
      trident: u.indexOf('Trident') > -1,
      //IE内核
      presto: u.indexOf('Presto') > -1,
      //opera内核
      webKit: u.indexOf('AppleWebKit') > -1,
      //苹果、谷歌内核
      gecko: u.indexOf('Gecko') > -1 && u.indexOf('KHTML') == -1,
      //火狐内核
      mobile: !!u.match(/AppleWebKit.*Mobile.*/),
      //是否为移动终端
      ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/),
      //ios终端
      android: u.indexOf('Android') > -1 || u.indexOf('Linux') > -1,
      //android终端或uc浏览器
      iPhone: u.indexOf('iPhone') > -1,
      //是否为iPhone或者QQHD浏览器
      iPad: u.indexOf('iPad') > -1,
      weixin: u.indexOf('MicroMessenger') > -1,
      //是否iPad
      webApp: u.indexOf('Safari') == -1,
      //是否web应该程序，没有头部与底部
      userId: userId,
      appId: appId,
      currentSiteId: currentSiteId,
    };
  })(),
  language: (navigator.browserLanguage || navigator.language).toLowerCase(),
  setMiniProgram: async () => {
    const status = await openInWXMiniprogram();
    if (status != undefined) {
      console.log(status, 'status');
      this.brower.version.weixin = !status;
      console.log('更新后微信标识', this.brower.version);
    }
  },
};
//获取用户标识
function getUserAgentKey(ua, key) {
  var arr = ua.substring(ua.search(key)).split(' ') || [],
    id = '';
  for (var i = 0, len = arr.length; i < len; i++) {
    if (arr[i].indexOf(key) > -1) {
      id = arr[i].replace(key, '');
      break;
    }
  }
  return id;
}
window.brower = brower;
// 是否为小程序环境打开
window.brower.setMiniProgram();
let inApp = function() {
  this.wxShareConfig = null;
};
let inAppFn = inApp.prototype;
//初始化分享
inAppFn.initShare = function(shareObj, url, cb) {
  if (brower.version.weixin) {
    this.setupShare(shareObj, url, cb);
  }
};
//获取微信分享签名
inAppFn.setupShare = function(shareObj, url, cb) {
  if (!brower.version.weixin) {
    return false;
  }
  if (!this.wxShareConfig) {
    var url2 = url ? url : location.href.split('#')[0]; //url不能写死
    wxApi.getWxConfig({ url: encodeURIComponent(url2) }).then(data => {
      this.wxShareConfig = data.data;

      this.setupShareData(shareObj, cb);
    });
  } else {
    this.setupShareData(shareObj, cb);
  }
};

//设置微信相关配置
inAppFn.setupShareData = function(shareObj, cb) {
  var data = this.wxShareConfig;
  wx.config({
    debug: false, ////生产环境需要关闭debug模式
    appId: data.appid, //appId通过微信服务号后台查看
    timestamp: data.timestamp, //生成签名的时间戳
    nonceStr: data.nonceStr, //生成签名的随机字符串
    signature: data.signature, //签名
    jsApiList: [
      //需要调用的JS接口列表
      'checkJsApi', //判断当前客户端版本是否支持指定JS接口
      'updateTimelineShareData', //分享给好友
      'updateAppMessageShareData', //分享到朋友圈
      'chooseWXPay', //微信支付api
      'scanQRCode',// 扫码
    ],
  });
  let defaultShareObj = {
    title: shareObj.title,
    desc: shareObj.desc,
    link: shareObj.link,
    imgUrl: shareObj.imgUrl,
    success: function() {
      console.log('设置成功啦！');
      if (cb && typeof cb == 'function') {
        cb();
      }
    },
  };
  wx.ready(function() {
    //分享朋友圈
    wx.updateTimelineShareData(defaultShareObj);
    //分享给好友
    wx.updateAppMessageShareData(defaultShareObj);
    wx.error(function(res) {
      console.log('errorRes:', res);
    });
  });
};
//判断ios当前版本
window.getIosVersion = inAppFn.getIosVersion = function() {
  var agent = window.navigator.userAgent,
    start = agent.indexOf('OS ');

  if (
    (agent.indexOf('iPhone') > -1 || agent.indexOf('iPad') > -1) &&
    start > -1
  ) {
    return window.Number(agent.substr(start + 3, 3).replace('_', '.'));
  }
  return 0;
};

//刷新微信缓存
inAppFn.refreshWeChatData = function() {
  if (!localStorage.pageLoadTime) {
    var myDate = new Date();
    localStorage.pageLoadTime = myDate.getTime();
  }
  localStorage.pageLoadTime = parseInt(localStorage.pageLoadTime);
  var myDate1 = new Date();
  let nowDate = myDate1.getTime();
  let before = parseInt(localStorage.pageLoadTime);
  console.log('now is ', nowDate, before);
  if (nowDate - before > 50000) {
    localStorage.pageLoadTime = myDate1.getTime();
    if (window.location.href.indexOf('?') > 0) {
      var url = window.location.href.split('?')[0];
      var paramStr = window.location.href.split('?')[1];
      if (paramStr.indexOf('&t=') == -1) {
        window.location.href =
          window.location.href +
          '&t=' +
          Math.random()
            .toString(36)
            .substr(2);
      } else {
        var index = paramStr.indexOf('&t=');
        paramStr = paramStr.substring(0, index);
        window.location.href =
          url +
          '?' +
          paramStr +
          '&t=' +
          Math.random()
            .toString(36)
            .substr(2);
      }
    } else {
      window.location.href =
        window.location.href +
        '?t=' +
        Math.random()
          .toString(36)
          .substr(2);
    }
    window.location.reload;
  }
};
function openInWXMiniprogram() {
  return new Promise((resolve, reject) => {
    var ua = window.navigator.userAgent.toLowerCase();
    if (ua.match(/MicroMessenger/i) == 'micromessenger') {
      //判断是否是微信环境
      console.log('当前环境为微信环境');
      //微信环境下
      if (
        ua.match(/miniprogram/i) === 'miniprogram' ||
        window.__wxjs_environment === 'miniprogram'
      ) {
        console.log('UA', '当前环境是否为小程序环境');
        resolve(true);
      } else {
        wx.miniProgram.getEnv(function(res) {
          console.log('getEnv', '当前环境是否为小程序环境', res.miniprogram);
          // 小程序环境下逻辑
          const isMiniprogram = res.miniprogram;
          resolve(!!isMiniprogram);
        });
      }
    } else {
      resolve();
    }
  });
}
export { inApp, brower, openInWXMiniprogram };



// WEBPACK FOOTER //
// ./src/common/wxJs/wx-util.js